import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: TerminalCountCellContent.Props["item"],
) => {
	if (!isNumber(item?.ordersCounters?.terminal?.count)) return "";
	return item.ordersCounters.terminal.count;
};

const TerminalCountCellContent: React.FC<TerminalCountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace TerminalCountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default TerminalCountCellContent;
